<template>
  <app-modal
    v-bind="$attrs"
    title="確認"
    ref="modal"
    class="modal-container"
    content-class="modal-full"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text class="pa-4">
        <div class="modal-body">
          <v-container fluid class="pa-0">
            <div class="font-weight-bold mb-3">
              本ルールを保存します。よろしいですか？
            </div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>IPマッピング</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ policy.policyId }}</td>
                  <td>
                    <policy-src-address
                      :src-address="{ srcAddressList: policy.srcAddressList }"
                    />
                  </td>
                  <td>
                    <template v-if="policy.ipMapping">{{
                      policy.ipMapping.ipMappingName
                    }}</template>
                    <template v-else>-</template>
                  </td>
                  <td>
                    {{ $filter.enumTo(policy.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(policy.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="flat" color="primary" @click="ok">はい</v-btn>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import PolicySrcAddress from "@/components/policy/PolicySrcAddress.vue";
import type { Type1DestinationNatPolicy } from "@/modals/applianceContractSetting/type1/policy/ipForwarding/InternetType1PolicyRuleDestNatViewRD.vue";

export default defineComponent({
  name: "InternetType1PolicyRuleDestNatConfirm",
  components: { PolicySrcAddress },
  props: {
    policy: {
      type: Object as PropType<Type1DestinationNatPolicy>,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
th {
  text-align: center !important;
}
</style>
